export default "__VITE_ASSET__ClGSTLFF__"